/**
 * Query keys for the recruiter surface.
 *
 * `details` (/me) and `settings` (/me/settings) are siblings under `all` so each
 * can be invalidated independently. That independence is load-bearing: the
 * Settings dialog absorbs exactly one refetch after an immediate file upload,
 * so a write that invalidates both keys would settle twice and the second sync
 * pass would discard the user's unsaved edits.
 *
 * For that reason `all` must only be used for a full reset (e.g. logout). Never
 * invalidate by the `all` prefix from a save or upload path — it matches both.
 */
export const RECRUITER_KEYS = {
  all: ["recruiter"] as const,
  details: () => [...RECRUITER_KEYS.all, "details"] as const,
  settings: () => [...RECRUITER_KEYS.all, "settings"] as const,
};
